<template>
  <validation-provider
    :disabled="!validatable"
    :name="fieldName || label"
    :rules="validatable ? rules : ''"
    :vid="vid"
    v-slot="validationContext"
    slim
  >
    <b-form-group
      v-bind="$attrs"
      :state="getValidationState(validatable, validationContext)"
      :label-cols-sm="noLabel ? undefined : labelColsSm"
      :class="controlClass"
      :label-class="labelClass"
    >
      <template slot="label">
        <div>
          {{ noLabel ? undefined : fieldLabel }}
          <base-help-icon :help-description="helpDescription" />
        </div>
      </template>
      <b-radio-group
        :state="getValidationState(validatable, validationContext)"
        class="mt-2"
        :checked="value"
        @input="emitValue"
        :stacked="stacked"
      >
        <b-radio
          v-for="(option, index) in radioOptions"
          :key="index"
          :value="valueFunc(option)"
          :disabled="option.disabled"
        >
          <template #default>
            <!-- @slot Radio option label -->
            <slot name="default" :option="option">
              {{ textFunc(option) }}
            </slot>
          </template>
        </b-radio>
        <b-form-invalid-feedback
          v-if="validatable"
          :state="getValidationState(validatable, validationContext)"
        >
          {{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </b-radio-group>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { BaseHelpIcon } from "./";
import { baseValidatableMixin } from "@foys-tech/foys-utils";
export default {
  mixins: [baseValidatableMixin],
  components: { BaseHelpIcon },
  props: {
    /**
     * Options list to display
     */
    options: null,
    /**
     * Property from option to display as label
     */
    textField: {
      type: String,
      default: "text",
    },
    /**
     * Function to prepare label for option. Ex. `(e) => e.title`
     */
    textFn: {
      type: Function,
      default: null,
    },
    /**
     * Property from option to use as value of selected option.
     */
    valueField: {
      type: String,
      default: "value",
    },
    /**
     * Function to build value of selected option. Ex. `(e) => e.value + 1`
     */
    valueFn: {
      type: Function,
      default: null,
    },
    /**
     * Show options as vertical list
     */
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    radioOptions() {
      return (
        this.options || [
          { text: this.$t("common.yes"), value: true },
          { text: this.$t("common.no"), value: false },
        ]
      );
    },
    textFunc() {
      return this.textFn ? this.textFn : (e) => e[this.textField];
    },
    valueFunc() {
      return this.valueFn ? this.valueFn : (e) => e[this.valueField];
    },
  },
};
</script>